import React from 'react'
import CustomModal from 'components/global/CustomModal'
import { Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import { leagueAttendanceStore } from 'state/league/leagueAttendance'
import LeagueCheckInOutTab from './Common/LeagueCheckInOutTab'
import LeagueHistoryTab from './Common/LeagueHistoryTab'

const CheckOutModal: React.FC = () => {
  const {
    checkOutModal,
    setCheckOutModal,
    setCheckInOutModalOpen,
    setSelectedAttendee,
  } = leagueAttendanceStore(store => ({
    checkOutModal: store.checkOutModal,
    setCheckOutModal: store.setCheckOutModal,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    setSelectedAttendee: store.setSelectedAttendee,
  }))

  const closeModal = () => {
    setSelectedAttendee(null)
    setCheckOutModal(false)
    setCheckInOutModalOpen(true)
  }

  return (
    <CustomModal
      openModal={checkOutModal}
      isCloseModalCustom
      closeModal={closeModal}
      title="Check-out details"
      width={1200}
      footer={false}
    >
      <>
        <Tabs defaultActiveKey="check-out">
          <TabPane tab="Check-out" key="check-out">
            <LeagueCheckInOutTab type="check-out" />
          </TabPane>
          <TabPane tab="History" key="history">
            <LeagueHistoryTab />
          </TabPane>
        </Tabs>
      </>
    </CustomModal>
  )
}

export default CheckOutModal
